import { createFileRoute } from "@tanstack/react-router";
import { buildHead } from "@/lib/seo-head";
import { SEGMENT_BY_SLUG } from "@/lib/segments";
import SegmentRoute from "@/pages/SegmentRoute";

export const Route = createFileRoute("/agente-ia-contabilidade")({
  head: () => buildHead({
    title: SEGMENT_BY_SLUG["agente-ia-contabilidade"]!.metaTitle,
    description: SEGMENT_BY_SLUG["agente-ia-contabilidade"]!.metaDescription,
    path: "/agente-ia-contabilidade",
  }),
  component: () => <SegmentRoute slug="agente-ia-contabilidade" />,
});
